import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fa34542"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-btn" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Horário", -1))
const _hoisted_3 = { class: "max-h-[285px] bg-white rounded-md" }
const _hoisted_4 = { class: "flex gap-1 justify-center items-center w-[149px] text-[16px] font-normal p-[16px]" }
const _hoisted_5 = { class: "relative flex w-[149px] text-[14px] font-normal pb-[16px] max-h-[190px] scrolbar-filter overflow-y-scroll" }
const _hoisted_6 = { class: "h-full flex flex-col items-center max-h-[190px] mr-[19px] ml-[13px]" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "h-full flex flex-col items-center max-h-[190px]" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_clock_icon = _resolveComponent("clock-icon")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createBlock(_component_Popper, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: "py-[4px] px-[5px] w-[55px] focus:bg-[#F0F0F4] focus-visible:outline-0 focus:rounded-t focus:border-t-0 focus:border-r-0 focus:border-l-0 focus:border-b-2 focus:border-[#2f7f91]",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.hourStart) = $event))
          }, null, 512), [
            [_vModelText, $setup.hourStart]
          ]),
          _createTextVNode(" - "),
          _withDirectives(_createElementVNode("input", {
            class: "py-[4px] px-[5px] w-[55px] focus:bg-[#F0F0F4] focus-visible:outline-0 focus:rounded-t focus:border-t-0 focus:border-r-0 focus:border-l-0 focus:border-b-2 focus:border-[#2f7f91]",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.hourEnd) = $event))
          }, null, 512), [
            [_vModelText, $setup.hourEnd]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionsHours, (hour) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "cursor-pointer p-[6px] hover:bg-gray-200",
                onClick: ($event: any) => ($setup.setHour('start', hour)),
                key: hour
              }, _toDisplayString(hour), 9, _hoisted_7))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionsHours, (hour) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "cursor-pointer p-[6px] hover:bg-gray-200",
                onClick: ($event: any) => ($setup.setHour('end', hour)),
                key: hour
              }, _toDisplayString(hour), 9, _hoisted_9))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.addFilter(`${$setup.hourStart}-${$setup.hourEnd}`))),
          class: "mt-1 cursor-pointer border border:bg-gray-100 w-full text-xs font-semibold py-1 h-[25px] rounded-b-md"
        }, " Aplicar ")
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_clock_icon),
        _hoisted_2
      ])
    ]),
    _: 1
  }))
}